// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconPresentationProps } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { rugPopupStyles } from "@rugby/App/Components/Tippy/Style";
import { LinkPresentationProps } from "@rugby/MobiusOverrides/Link";
import { css } from "styled-components";

export interface RecentlyPurchasedMenuStyles {
    container?: InjectableCss;
    headerWrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    viewAllLink?: LinkPresentationProps;
    statusContainer?: InjectableCss;
    closeButton?: IconPresentationProps;
}

export const recentlyPurchasedMenuStyles: RecentlyPurchasedMenuStyles = {
    container: {
        css: css`
            padding: 30px;
            width: 100%;
            min-width: 600px;
            display: flex;
            flex-direction: column;

            .carouselContainer {
                margin-bottom: 0;
            }
            .carouselTitle {
                display: none;
            }
            .carouselNextGrid {
                right: -30px;
            }
            .carouselPrevGrid {
                left: -30px;
            }
        `,
    },
    headerWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 20px;
            margin-bottom: 30px;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
    titleText: {
        variant: "h3",
        size: 28,
        color: "text.main",
        css: css`
            margin: 0;
            letter-spacing: 0;
            line-height: 30px;
        `,
    },
    viewAllLink: {
        withIcon: true,
        color: "secondary",
        typographyProps: {
            size: 15,
        },
        css: css`
            font-weight: bold;
            letter-spacing: 0;
            line-height: 18px;
            &&&:hover span:not(.link-with-icon) {
                color: ${getColor("secondary")};
            }
            &&&:hover span.link-with-icon {
                color: ${getColor("text.main")};
            }
        `,
    },
    statusContainer: {
        css: css`
            margin: auto;
        `,
    },
    closeButton: {
        ...rugPopupStyles.closeButton
    },
};
